//this comes from the deploy-time realmConfig.js, imported by index.html
//in unit test, jest.presets.js sets this as a global

declare const realmConfig: any
export type Realm = 'alpha' | 'beta' | 'stg1' | 'stg2' | 'prd1' | 'prd2'
export type CwanEnvironment =
  | 'localDevServer'
  | 'unittest'
  | 'dev'
  | 'staging'
  | 'prod'

/**
 * This is identical to realmConfig.beta.js, but we just paste it here so Typescript knows the schema,
 *   and also so that localhost dev just works without any changes
 * to change realmConfig during localhost development, edit index.html to specify which realmConfig.*.js you want
 */
export const environment = {
  realm: 'beta' as Realm,
  environment: 'localDevServer' as CwanEnvironment,
  production: false,
  test: false,
  sidenavBaseUrl: 'https://console.uswe2.beta.aws.cwan.io/nav',
  axiomReportsApi: 'https://axiom-reporting-ws.uswe2.beta.aws.cwan.io/',

  ...realmConfig, //override with realm-specific settings from realmConfig.js
}
